import { render, staticRenderFns } from "./ModalView.vue?vue&type=template&id=73052884&scoped=true&"
import script from "./ModalView.vue?vue&type=script&lang=ts&"
export * from "./ModalView.vue?vue&type=script&lang=ts&"
import style0 from "./ModalView.vue?vue&type=style&index=0&id=73052884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73052884",
  null
  
)

export default component.exports